import callApi, { METHOD_TYPE } from '../utils/callApi'
import { FRAME } from '../mutations'
import { filter, cloneDeep, reduce } from 'lodash'
import { frameFormat } from '../constants'

const state = {
  frame: {},
  framelist: [],
  actionNames: {},
  actionList: {},
  segmentList: {},
  domainlist: {},
  fqdn: '',
  actionType: 'popup',
  nonRatio: 100
}

const mutations = {
  [FRAME.FRAME_LIST](state, payload) { state.framelist = payload },
  [FRAME.DOMAIN_LIST](state, payload) { state.domainlist = payload },
  [FRAME.FRAME_GET](state, payload) {
    state.frame = payload
    state.nonRatio = 100 - reduce(state.frame.configuration.actions, function(ratioSum, value, key) {
      return ratioSum + Number(value.ratio)
    }, 0)
  },
  [FRAME.ACTION_GET](state, payload) { state.actionNames[payload.actionId] = payload.metadata.name },
  [FRAME.ACTION_LIST](state, payload) { state.actionList = payload },
  [FRAME.SEGMENT_LIST](state, payload) {
    console.log()
    state.segmentList = payload
  },
  [FRAME.RATIO_CHANGE](state) {
    let nonRatio = 100 - reduce(state.frame.configuration.actions, function(ratioSum, value, key) {
      return ratioSum + Number(value.ratio)
    }, 0)
    if (nonRatio < 0) {
      state.nonRatio = 0
    } else if (nonRatio > 100) {
      state.nonRatio = 100
    } else {
      state.nonRatio = nonRatio
    }
  },
  [FRAME.ACTION_TYPE](state, payload) { state.actionType = payload }
}

const actions = {
  getFrameListData({ commit }, fqdn) {
    callApi('/delivery/list-frame', METHOD_TYPE.POST, { 'fqdn': fqdn })
    .then((response) => {
      commit(FRAME.FRAME_LIST, response.body.frames)
    }).catch(e => {
      if (e.response == null) {
        alert('枠の取得に失敗しました。' + '\n' + e.message)
      } else {
        location.href = '#/error/' + e.status
        alert('枠の取得に失敗しました。' + '\n[' + e.message + ']' + JSON.parse(e.response.text).error.message)
      }
    })
  },
  getDomainListData({ commit }) {
    callApi('/delivery/list-domain', METHOD_TYPE.POST, {})
    .then((response) => {
      commit(FRAME.DOMAIN_LIST, response.body.domains)
    }).catch(e => {
      if (e.response == null) {
        alert('ドメインの取得に失敗しました。' + '\n' + e.message)
      } else {
        location.href = '#/error/' + e.status
        alert('ドメインの取得に失敗しました。' + '\n[' + e.message + ']' + JSON.parse(e.response.text).error.message)
      }
    })
  },
  getFrameData({ commit }, frameInf) {
    callApi('/delivery/get-frame', METHOD_TYPE.POST, { 'fqdn': frameInf.fqdn, 'frameId': frameInf.frameId })
    .then((response) => {
      commit(FRAME.FRAME_GET, response.body.frame)
      // actionのnameが欲しいのでforぶん回す必要がある。改善方法があったら後で修正。
      for (let i = 0; i < state.frame.configuration.actions.length; i++) {
        callApi('/delivery/get-action', METHOD_TYPE.POST, { 'actionId': state.frame.configuration.actions[i].actionId })
        .then((response) => {
          commit(FRAME.ACTION_GET, response.body.action)
          commit(FRAME.ACTION_TYPE, response.body.action.metadata.type)
          if (i === 0) {
            callApi('/delivery/list-action', METHOD_TYPE.POST, { })
            .then((response1) => {
              commit(FRAME.ACTION_LIST, filter(response1.body.actions, { 'metadata': { 'type': response.body.action.metadata.type } }))
            })
          }
        }).catch(e => {
          this.errors.push(e)
        })
      }
    }).catch(e => {
      if (e.response == null) {
        alert('ドメインの取得に失敗しました。' + '\n' + e.message)
      } else {
        location.href = '#/error/' + e.status
        alert('ドメインの取得に失敗しました。' + '\n[' + e.message + ']' + JSON.parse(e.response.text).error.message)
      }
    })
  },
  formatFrameData({ commit }, fqdn) {
    let frame = cloneDeep(frameFormat)
    frame.fqdn = fqdn
    frame.configuration.pages[0].mode = ''
    commit(FRAME.FRAME_GET, frame)
  },
  getActionList({ commit }, actionType) {
    callApi('/delivery/list-action', METHOD_TYPE.POST, { })
    .then((response) => {
      commit(FRAME.ACTION_LIST, filter(response.body.actions, { 'metadata': { 'type': actionType } }))
    })
  },
  getSegmentList({ commit }, segment) {
    callApi('/delivery/list-segment', METHOD_TYPE.POST, { })
    .then((response) => {
      commit(FRAME.SEGMENT_LIST, response.body.segments)
    })
  },
  createFrame({ commit }, router) {
    let params = state.frame
    callApi('/delivery/create-frame', METHOD_TYPE.POST, params)
    .then((response) => {
      alert('枠の登録に成功しました')
      router.push('/delivery/list-frame')
    })
    .catch(e => {
      if (e.response == null) {
        alert('枠の登録に失敗しました。' + '\n' + e.message)
      } else {
        alert('枠の登録に失敗しました。' + '\n[' + e.message + ']' + JSON.parse(e.response.text).error.message)
      }
    })
  },
  updateFrame({ commit }, router) {
    let updateparams = state.frame
    callApi('/delivery/update-frame', METHOD_TYPE.POST, updateparams)
    .then((response) => {
      alert('枠の更新に成功しました')
      router.push('/delivery/list-frame')
    })
    .catch(e => {
      if (e.response == null) {
        alert('枠の更新に失敗しました。' + '\n' + e.message)
      } else {
        alert('枠の更新に失敗しました。' + '\n[' + e.message + ']' + JSON.parse(e.response.text).error.message)
      }
    })
  },
  frameDelete({ commit }, frame) {
    callApi('/delivery/delete-frame', METHOD_TYPE.POST, { fqdn: frame.fqdn, frameId: frame.frameId, versionId: frame.versionId })
    .then((response) => {
      commit(FRAME.FRAME_LIST, state.framelist.filter(n => n !== frame))
    })
    .catch(e => {
      if (e.response == null) {
        alert('枠の削除に失敗しました。' + '\n' + e.message)
      } else {
        location.href = '#/error/' + e.status
        alert('枠の削除に失敗しました。' + '\n[' + e.message + ']' + JSON.parse(e.response.text).error.message)
      }
    })
  },
  ratioChange({ commit }) {
    commit(FRAME.RATIO_CHANGE)
  }
}

export default { state, actions, mutations }



// WEBPACK FOOTER //
// ./src/stores/frame.js